import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import cx from 'clsx';

import { TokenAvatar, Modal, Loading } from '@/components';
import { useSwitch } from '@/hooks';
import { withHttp, shorten, formatNum } from '@/utils';

import { useUserNftList } from '../hook';
import { ActionWrapper, ActionProps } from './Wrapper';
import style from './index.module.scss';

export const NftHolder = (props: ActionProps) => {
  const { data: action } = props;

  const { on, turnOn, turnOff } = useSwitch();
  return (
    <>
      <ActionWrapper
        {...props}
        onActionClick={turnOn}
        avatar={
          <TokenAvatar
            className={style.actionIcon}
            logo={action.data.logo_url}
            chain={action.data.chain_id}
            size={16}
            isNft
          />
        }>
        [
        {action.data.collection_name ||
          (action.data.collection_id && shorten(action.data.collection_id, 6, 4)) ||
          ''}
        ] <Trans i18nKey="QuestCard_consts.nftHolder" />
      </ActionWrapper>
      {on ? <ConfirmModal action={action} turnOff={turnOff} /> : null}
    </>
  );
};

const { CommonModal } = Modal;

const ConfirmModal = ({
  action,
  turnOff,
}: {
  turnOff: () => void;
  action: ActionProps['data'];
}) => {
  const { t } = useTranslation();

  const { data, isLoading } = useUserNftList(action.data.collection_id!, action.data.chain_id!);

  const collectId = data?.collection_dict ? Object.keys(data?.collection_dict)[0] : '';
  const nft = data?.collection_dict?.[collectId];
  const sum = data?.token_list?.reduce((a, n) => a + n.amount, 0);

  return (
    <CommonModal turnOff={turnOff} containerClassName={style.confirmModal}>
      <div className={style.cmTitle}>
        <TokenAvatar
          className={style.actionIcon}
          logo={action.data.logo_url}
          chain={action.data.chain_id}
          size={20}
          isNft
        />
        {t('Actions_NftHolder.rm6hm8')}
      </div>
      <div className={style.cmField}>
        <div className={style.cmfTitle}>{t('Actions_NftHolder.1cikr7n')}</div>
        {isLoading ? (
          <Loading />
        ) : data?.token_list?.length ? (
          <div className={style.cmTable}>
            <div className={style.col}>
              <div className={style.colTitle}>NFT</div>
              <div className={style.colVal}>
                <TokenAvatar
                  className={style.actionIcon}
                  logo={nft?.logo_url}
                  chain={action.data.chain_id}
                  size={20}
                  isNft
                />
                <span className={style.tokenName}>{nft?.name}</span>
              </div>
            </div>
            <div className={style.col}>
              <div className={style.colTitle}>{t('Actions_NftHolder.whwdbs')}</div>
              <div className={style.colVal}>{formatNum(sum) || '-'}</div>
            </div>
          </div>
        ) : (
          <div className={cx(style.cmfBgValue, style.unhold)}>{t('Actions_NftHolder.1upzc7r')}</div>
        )}
      </div>
      <div className={style.cmField}>
        <div className={style.cmfTitle}>{t('Actions_NftHolder.12yr0ym')}</div>
        <a
          href={withHttp(action.data.action_url!)}
          target="_blank"
          rel="noreferrer"
          aria-label="verify link"
          className={style.cmLink}>
          {action.data.action_url}
        </a>
      </div>
    </CommonModal>
  );
};
